import axios from "axios";

import { store } from "./store";

var client = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
});

client.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

client.interceptors.response.use(
  function (response) {
    return response;
  },

  function (error) {
    let url = error.config.url;
    let base_url = error.config.baseURL;
    let rota_atual = url.replace(base_url, "");

    if (
      rota_atual == `${process.env.VUE_APP_REFRESH_URL_PREFIX}refresh` &&
      error.response.status == 401
    ) {
      store.dispatch("logoff");
    }

    if (
      rota_atual === `${process.env.VUE_APP_LOGIN_URL_PREFIX}login` &&
      error.response.status === 401
    ) {
      store.commit("set_message", {
        message: error.response.data.error,
        color: "error",
        type: "error",
      });
    }
    return Promise.reject(error);
  }
);

client.vue_login = function () {
  this.defaults.headers["Authorization"] = store.getters.token;
};

export default client;
